import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';
import '../styles/mainPage.css';

const SessionTimeoutModal = ({ isVisible, onExtend, onLogout, remainingTime }) => {
    const [countdown, setCountdown] = useState(remainingTime || 60);
    const navigate = useNavigate();
    const { logout } = useAuth();

    useEffect(() => {
        if (!isVisible) return;

        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    handleAutoLogout();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [isVisible]);

    const handleAutoLogout = async () => {
        try {
            await logout();
            navigate('/');
        } catch (error) {
            navigate('/');
        }
    };

    const handleExtendSession = async () => {
        try {
            await onExtend();
        } catch (error) {
            handleAutoLogout();
        }
    };

    const handleManualLogout = async () => {
        try {
            await onLogout();
            navigate('/');
        } catch (error) {
            navigate('/');
        }
    };

    if (!isVisible) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            backdropFilter: 'blur(4px)'
        }}>
            <div style={{
                background: 'rgba(15,23,42,0.95)',
                borderRadius: 20,
                padding: '2rem',
                maxWidth: 400,
                width: '90%',
                border: '1px solid rgba(59, 130, 246, 0.3)',
                boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
            }}>
                <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                    <div style={{
                        width: 60,
                        height: 60,
                        borderRadius: '50%',
                        background: 'rgba(239, 68, 68, 0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 1rem'
                    }}>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"/>
                            <polyline points="12,6 12,12 16,14"/>
                        </svg>
                    </div>
                    <h3 style={{
                        color: '#fff',
                        fontSize: '1.5rem',
                        fontWeight: 700,
                        marginBottom: '0.5rem'
                    }}>
                        Session Expiring Soon
                    </h3>
                    <p style={{
                        color: '#b6c6e3',
                        fontSize: '0.95rem',
                        lineHeight: 1.4
                    }}>
                        Your session will expire in {countdown} second{countdown !== 1 ? 's' : ''}. 
                        Would you like to extend your session?
                    </p>
                </div>

                <div style={{
                    display: 'flex',
                    gap: '0.75rem',
                    flexDirection: 'column'
                }}>
                    <button
                        onClick={handleExtendSession}
                        style={{
                            background: '#3b82f6',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 12,
                            padding: '0.75rem 1rem',
                            fontSize: '0.95rem',
                            fontWeight: 600,
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            width: '100%'
                        }}
                        onMouseOver={(e) => e.target.style.background = '#2563eb'}
                        onMouseOut={(e) => e.target.style.background = '#3b82f6'}
                    >
                        Extend Session
                    </button>
                    
                    <button
                        onClick={handleManualLogout}
                        style={{
                            background: 'transparent',
                            color: '#b6c6e3',
                            border: '1px solid #374151',
                            borderRadius: 12,
                            padding: '0.75rem 1rem',
                            fontSize: '0.95rem',
                            fontWeight: 500,
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            width: '100%'
                        }}
                        onMouseOver={(e) => {
                            e.target.style.background = 'rgba(239, 68, 68, 0.1)';
                            e.target.style.borderColor = '#ef4444';
                            e.target.style.color = '#ef4444';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.background = 'transparent';
                            e.target.style.borderColor = '#374151';
                            e.target.style.color = '#b6c6e3';
                        }}
                    >
                        Logout Now
                    </button>
                </div>

                <div style={{
                    textAlign: 'center',
                    marginTop: '1rem',
                    padding: '0.75rem',
                    background: 'rgba(239, 68, 68, 0.1)',
                    borderRadius: 8,
                    border: '1px solid rgba(239, 68, 68, 0.2)'
                }}>
                    <p style={{
                        color: '#ef4444',
                        fontSize: '0.85rem',
                        margin: 0,
                        fontWeight: 500
                    }}>
                        ⚠️ Auto-logout in {countdown}s if no action taken
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SessionTimeoutModal;
